module.exports = __webpack_public_path__ + "static/background-image-xs-ac6a0c5eff85943e2108e272fc2f9771.webm";